export default "__VITE_ASSET__BJFnVP2r__"